export default __webpack_public_path__ + "static/media/logout.f39b184b.svg";